import { Component, ViewEncapsulation, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { ModelsService } from '@irb/irb-models//models-new/models.service';
import { IrbAppEvents, IrbModelsEvents } from '@irb-common/events';
import { UtilityService } from '@irb-common/services/utility.service';
import { IAlertDialogData } from '@irb/app.model';

@Component({ standalone: false,
  selector: 'irb-import-security-models-dialog',
  templateUrl: './import-security-models-dialog.component.html',
  styleUrls: ['./import-security-models-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportSecurityModelsDialogComponent implements OnInit {
  file: any;
  hasFile: boolean = false;
  isValidFile: boolean = false;
  invalidFileErrorHeader: string;
  invalidFileErrorMessage: string;
  errorMessage: string ;
  progressTimer: any = null;
  updateStatusCount = 0;
  isUiTest = false;

  constructor(
    public dialogRef: MatDialogRef<ImportSecurityModelsDialogComponent>,
    public as: AppService,
    public modelsService: ModelsService,
    private util: UtilityService
  ) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onFileChange(event: any) {
    this.file = event.target.files[0];
    this.hasFile = this.isValidFile = true;
    if (!this.file.name.endsWith('.csv')) {
      this.isValidFile = false;
      this.invalidFileErrorHeader = "Invalid file format.";
      this.invalidFileErrorMessage = "Extension type must be \".csv\"";
    }
    if (this.as.maxFileUploadSizeExceeded(this.file)) {
      this.triggerMaxFileUploadSizeExceededError();
    }
    this.errorMessage = "";
  }

  private triggerMaxFileUploadSizeExceededError() {
    this.isValidFile = false;
    this.invalidFileErrorHeader = "Invalid file size.";
    this.invalidFileErrorMessage = "File size exceeds 50MB limit.";
  }

  actionStatusCheckFailed() {
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    this.close();
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        dType: 'ERROR',
        dTitle: '',
        dProceedBtnLabel: '',
        msg: 'An error occurred processing your request.',
        onProceed: () => {
        }
    } as IAlertDialogData);
  }

  updateProgressBarStatus(response: any) {
    let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
    if (this.isUiTest)
        timeout = 0;
    this.updateStatusCount++;
    this.progressTimer = setTimeout(() => {
      this.checkIntervalStart(response.statusId);
    }, timeout);
  }

  checkIntervalStart(statusId: any) {
    this.modelsService.validateImportSecModelsAsyncStatus(statusId).subscribe((statusResponse: any) => {
        if (statusResponse.responseStatus === "SUCCESS") {
            const response = statusResponse?.responseUtilityMap;
            const reqStatus = response?.reqStatus?.trim().toUpperCase();
            if (reqStatus === 'FAILED') {
                this.actionStatusCheckFailed();
            }

            if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
                this.updateProgressBarStatus(response);
            }
            if (reqStatus === 'COMPLETED') {
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                if (this.progressTimer) clearTimeout(this.progressTimer);
                this.processValidateSecModelsAsyncResponse(statusResponse.responseData);
            }
        } else {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          this.close();
          if (this.progressTimer) clearTimeout(this.progressTimer);
        }
    }, () => {
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if (this.progressTimer) clearTimeout(this.progressTimer);
    });
  }

  processValidateSecModelsAsyncResponse(res: any) {
    if (res.includes('Max upload size exceeded')) {
      this.triggerMaxFileUploadSizeExceededError();
    } else {
      const response = JSON.parse(res.substring(res.indexOf('<textarea>') + 10, res.indexOf('</textarea>')));

      if(!response.CSVinValidFormat){
        this.errorMessage ="Use our .csv template to prepare your file.";
        return;
      }

      if (response.status && response.status === "fail") {
        if (response.message) {
          this.errorMessage = response.message;
        } else {
          this.isValidFile = false;
        }
        return;
      }

      const modelsToAdd = (response.modelsToAdd && response.modelsToAdd.length > 0);
      const validatedModels = (response.validatedModels && response.validatedModels.length > 0);
      const unrecognizedSecurites = (response.unrecognized);
      const containsSecurites = (response.noninventoried.Models && response.noninventoried.Models.length > 0);


      if(unrecognizedSecurites){
        this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_MODELS_UNRECOGNIZED, response);
      }else if(containsSecurites){
        this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_MODELS_CONTAINS, response);
      } else if(validatedModels) {
        this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_MODELS_RESULT, response);

      }
      this.close();
    }
  }

  submitFile() {
    const f = new FormData();
    f.append('ImportModel', this.file, this.file.name);

    this.modelsService.importSecurityModelsAsync(f).subscribe({
      next:  (data: any) => {
          if (this.progressTimer) clearTimeout(this.progressTimer);
          if (data.responseStatus === "SUCCESS") {
              this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
              this.checkIntervalStart(data.responseUtilityMap.statusId);
          } else {
              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                  severity: 'error',
                  summary: 'Import Security Models',
                  detail: " An error occurred processing your request."
              });
          }
      }, error: () => {}
    });
  }
}
